// extracted by css-extract-rspack-plugin
export default {"old":"product-detail-fragment__useReadMoreVisibility_old__ZNqiX"};